var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./UI/Button/Button", "./UI/Button/ConcertButton", "./UI/Dropdown/Dropdown", "./UI/Icon/Icon", "./UI/Icon/IconSvg", "./UI/Interchange/Interchange", "./UI/LandscapeImage/LandscapeImage", "./UI/LinkImageList/LinkImageListConcert", "./UI/Loader/Loader", "./UI/Modal/Modal", "./UI/NextSharebar/NextSharebar", "./UI/NextSubscribe/NextSubscribe", "./UI/Overlay/Overlay", "./UI/RichText/RichText", "./UI/Sticker/Sticker", "./UI/Tag/Tag", "./UI/VideoThumbnail/VideoThumbnail", "./UI/ScrollTop/ScrollTop", "./UI/TitlePlaceholder/TitlePlaceholder", "./UI/VideoEmbed/VideoEmbed", "./UI/NoResult/NoResult", "./Layout/NextFooter/NextFooter", "./Layout/NextMenu/NextMenu", "./Banners/BigBanner/BigBanner", "./Banners/Banner/Banner", "./Banners/CookieBanner/CookieBanner", "./Teasers/TeaserMain/TeaserMain", "./Teasers/TeaserSeeAll/TeaserSeeAll", "./Teasers/TeaserShow/TeaserShow", "./Teasers/TeaserSidebar/TeaserSidebar", "./Teasers/TeaserVideo/TeaserVideo", "./Teasers/TeaserVOD/TeaserVOD", "./Teasers/TeasersList/TeasersList", "./Teasers/TeasersRow/TeasersRow", "./Teasers/TeaserPreview/TeaserPreview", "./Sliders/LandscapeSlider/LandscapeSlider", "./Sliders/SmallSquareSlider/SmallSquareSlider", "./Sliders/SingleLineSlider/SingleLineSlider", "./Sliders/MultiLineSlider/MultiLineSlider", "./Sliders/HomeMainSlider/HomeMainSlider", "./Sliders/PortraitSlider/PortraitSlider", "./Next/LinksList/Link", "./Next/LinksList/LinksList", "./Next/NavBar/NavBar", "./Next/NavBar/NavBarLink", "./Next/SectionBreadcrumb/SectionBreadcrumb", "./Next/SectionTitle/SectionTitle", "./Next/ProgramTimeline/ProgramTimeline", "./Next/GuideDaySlider/GuideDaySlide", "./Next/GuideDaySlider/GuideDaySlider", "./Next/GuideMainSlider/GuideMainSlider", "./Next/GuideProgram/GuideProgram", "./Next/PreviousPrograms/PreviousPrograms", "./Next/ProgramBreadcrumb/ProgramBreadcrumb", "./Next/ProgramCartridge/ProgramCartridge", "./Next/ProgramCredits/ProgramCredits", "./Next/ProgramExternalLinks/ProgramExternalLinks", "./Next/ProgramInfos/ProgramInfos", "./Next/ProgramSidebar/ProgramSidebar", "./Next/ProgramPlaylist/ProgramPlaylist", "./Next/SearchDurationFilter/SearchDurationFilter", "./Next/SearchInput/SearchInput", "./Next/SearchTeaser/SearchTeaser", "./Next/SearchTeasersList/SearchTeasersList", "./Next/CollectionDescription/CollectionDescription", "./Next/LiveInfos/LiveInfos", "./PAPA/DateLabel/DateLabel", "./PAPA/Quote/Quote", "./PAPA/ImageWithLegend/ImageWithLegend", "./PAPA/SocialMedia/SocialMedia", "./PAPA/Carousel/Carousel", "./AFP/AfpImage/AfpImage", "./Club/TeaserEvent/TeaserEvent", "./Club/TeaserEventInfos/TeaserEventInfos", "./Presse/TeaserLandscape/TeaserLandscape", "./Presse/HomeMainCarousel/HomeMainCarousel"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./UI/Button/Button"), require("./UI/Button/ConcertButton"), require("./UI/Dropdown/Dropdown"), require("./UI/Icon/Icon"), require("./UI/Icon/IconSvg"), require("./UI/Interchange/Interchange"), require("./UI/LandscapeImage/LandscapeImage"), require("./UI/LinkImageList/LinkImageListConcert"), require("./UI/Loader/Loader"), require("./UI/Modal/Modal"), require("./UI/NextSharebar/NextSharebar"), require("./UI/NextSubscribe/NextSubscribe"), require("./UI/Overlay/Overlay"), require("./UI/RichText/RichText"), require("./UI/Sticker/Sticker"), require("./UI/Tag/Tag"), require("./UI/VideoThumbnail/VideoThumbnail"), require("./UI/ScrollTop/ScrollTop"), require("./UI/TitlePlaceholder/TitlePlaceholder"), require("./UI/VideoEmbed/VideoEmbed"), require("./UI/NoResult/NoResult"), require("./Layout/NextFooter/NextFooter"), require("./Layout/NextMenu/NextMenu"), require("./Banners/BigBanner/BigBanner"), require("./Banners/Banner/Banner"), require("./Banners/CookieBanner/CookieBanner"), require("./Teasers/TeaserMain/TeaserMain"), require("./Teasers/TeaserSeeAll/TeaserSeeAll"), require("./Teasers/TeaserShow/TeaserShow"), require("./Teasers/TeaserSidebar/TeaserSidebar"), require("./Teasers/TeaserVideo/TeaserVideo"), require("./Teasers/TeaserVOD/TeaserVOD"), require("./Teasers/TeasersList/TeasersList"), require("./Teasers/TeasersRow/TeasersRow"), require("./Teasers/TeaserPreview/TeaserPreview"), require("./Sliders/LandscapeSlider/LandscapeSlider"), require("./Sliders/SmallSquareSlider/SmallSquareSlider"), require("./Sliders/SingleLineSlider/SingleLineSlider"), require("./Sliders/MultiLineSlider/MultiLineSlider"), require("./Sliders/HomeMainSlider/HomeMainSlider"), require("./Sliders/PortraitSlider/PortraitSlider"), require("./Next/LinksList/Link"), require("./Next/LinksList/LinksList"), require("./Next/NavBar/NavBar"), require("./Next/NavBar/NavBarLink"), require("./Next/SectionBreadcrumb/SectionBreadcrumb"), require("./Next/SectionTitle/SectionTitle"), require("./Next/ProgramTimeline/ProgramTimeline"), require("./Next/GuideDaySlider/GuideDaySlide"), require("./Next/GuideDaySlider/GuideDaySlider"), require("./Next/GuideMainSlider/GuideMainSlider"), require("./Next/GuideProgram/GuideProgram"), require("./Next/PreviousPrograms/PreviousPrograms"), require("./Next/ProgramBreadcrumb/ProgramBreadcrumb"), require("./Next/ProgramCartridge/ProgramCartridge"), require("./Next/ProgramCredits/ProgramCredits"), require("./Next/ProgramExternalLinks/ProgramExternalLinks"), require("./Next/ProgramInfos/ProgramInfos"), require("./Next/ProgramSidebar/ProgramSidebar"), require("./Next/ProgramPlaylist/ProgramPlaylist"), require("./Next/SearchDurationFilter/SearchDurationFilter"), require("./Next/SearchInput/SearchInput"), require("./Next/SearchTeaser/SearchTeaser"), require("./Next/SearchTeasersList/SearchTeasersList"), require("./Next/CollectionDescription/CollectionDescription"), require("./Next/LiveInfos/LiveInfos"), require("./PAPA/DateLabel/DateLabel"), require("./PAPA/Quote/Quote"), require("./PAPA/ImageWithLegend/ImageWithLegend"), require("./PAPA/SocialMedia/SocialMedia"), require("./PAPA/Carousel/Carousel"), require("./AFP/AfpImage/AfpImage"), require("./Club/TeaserEvent/TeaserEvent"), require("./Club/TeaserEventInfos/TeaserEventInfos"), require("./Presse/TeaserLandscape/TeaserLandscape"), require("./Presse/HomeMainCarousel/HomeMainCarousel"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Button, global.ConcertButton, global.Dropdown, global.Icon, global.IconSvg, global.Interchange, global.LandscapeImage, global.LinkImageListConcert, global.Loader, global.Modal, global.NextSharebar, global.NextSubscribe, global.Overlay, global.RichText, global.Sticker, global.Tag, global.VideoThumbnail, global.ScrollTop, global.TitlePlaceholder, global.VideoEmbed, global.NoResult, global.NextFooter, global.NextMenu, global.BigBanner, global.Banner, global.CookieBanner, global.TeaserMain, global.TeaserSeeAll, global.TeaserShow, global.TeaserSidebar, global.TeaserVideo, global.TeaserVOD, global.TeasersList, global.TeasersRow, global.TeaserPreview, global.LandscapeSlider, global.SmallSquareSlider, global.SingleLineSlider, global.MultiLineSlider, global.HomeMainSlider, global.PortraitSlider, global.Link, global.LinksList, global.NavBar, global.NavBarLink, global.SectionBreadcrumb, global.SectionTitle, global.ProgramTimeline, global.GuideDaySlide, global.GuideDaySlider, global.GuideMainSlider, global.GuideProgram, global.PreviousPrograms, global.ProgramBreadcrumb, global.ProgramCartridge, global.ProgramCredits, global.ProgramExternalLinks, global.ProgramInfos, global.ProgramSidebar, global.ProgramPlaylist, global.SearchDurationFilter, global.SearchInput, global.SearchTeaser, global.SearchTeasersList, global.CollectionDescription, global.LiveInfos, global.DateLabel, global.Quote, global.ImageWithLegend, global.SocialMedia, global.Carousel, global.AfpImage, global.TeaserEvent, global.TeaserEventInfos, global.TeaserLandscape, global.HomeMainCarousel);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _Button2, _ConcertButton2, _Dropdown2, _Icon2, _IconSvg2, _Interchange2, _LandscapeImage2, _LinkImageListConcert2, _Loader2, _Modal2, _NextSharebar2, _NextSubscribe2, _Overlay2, _RichText2, _Sticker2, _Tag2, _VideoThumbnail2, _ScrollTop2, _TitlePlaceholder2, _VideoEmbed2, _NoResult2, _NextFooter2, _NextMenu2, _BigBanner2, _Banner2, _CookieBanner2, _TeaserMain2, _TeaserSeeAll2, _TeaserShow2, _TeaserSidebar2, _TeaserVideo2, _TeaserVOD2, _TeasersList2, _TeasersRow2, _TeaserPreview2, _LandscapeSlider2, _SmallSquareSlider2, _SingleLineSlider2, _MultiLineSlider2, _HomeMainSlider2, _PortraitSlider2, _Link2, _LinksList2, _NavBar2, _NavBarLink2, _SectionBreadcrumb2, _SectionTitle2, _ProgramTimeline2, _GuideDaySlide2, _GuideDaySlider2, _GuideMainSlider2, _GuideProgram2, _PreviousPrograms2, _ProgramBreadcrumb, _ProgramCartridge, _ProgramCredits, _ProgramExternalLinks, _ProgramInfos, _ProgramSidebar, _ProgramPlaylist, _SearchDurationFilter, _SearchInput2, _SearchTeaser2, _SearchTeasersList2, _CollectionDescription2, _LiveInfos2, _DateLabel2, _Quote2, _ImageWithLegend2, _SocialMedia2, _Carousel2, _AfpImage2, _TeaserEvent2, _TeaserEventInfos2, _TeaserLandscape, _HomeMainCarousel2) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _Object$defineProperty(_exports, "Button", {
    enumerable: true,
    get: function get() {
      return _Button2.default;
    }
  });

  _Object$defineProperty(_exports, "ConcertButton", {
    enumerable: true,
    get: function get() {
      return _ConcertButton2.default;
    }
  });

  _Object$defineProperty(_exports, "Dropdown", {
    enumerable: true,
    get: function get() {
      return _Dropdown2.default;
    }
  });

  _Object$defineProperty(_exports, "Icon", {
    enumerable: true,
    get: function get() {
      return _Icon2.default;
    }
  });

  _Object$defineProperty(_exports, "IconSvg", {
    enumerable: true,
    get: function get() {
      return _IconSvg2.default;
    }
  });

  _Object$defineProperty(_exports, "Interchange", {
    enumerable: true,
    get: function get() {
      return _Interchange2.default;
    }
  });

  _Object$defineProperty(_exports, "LandscapeImage", {
    enumerable: true,
    get: function get() {
      return _LandscapeImage2.default;
    }
  });

  _Object$defineProperty(_exports, "LinkImageListConcert", {
    enumerable: true,
    get: function get() {
      return _LinkImageListConcert2.default;
    }
  });

  _Object$defineProperty(_exports, "Loader", {
    enumerable: true,
    get: function get() {
      return _Loader2.default;
    }
  });

  _Object$defineProperty(_exports, "Modal", {
    enumerable: true,
    get: function get() {
      return _Modal2.default;
    }
  });

  _Object$defineProperty(_exports, "NextSharebar", {
    enumerable: true,
    get: function get() {
      return _NextSharebar2.default;
    }
  });

  _Object$defineProperty(_exports, "NextSubscribe", {
    enumerable: true,
    get: function get() {
      return _NextSubscribe2.default;
    }
  });

  _Object$defineProperty(_exports, "Overlay", {
    enumerable: true,
    get: function get() {
      return _Overlay2.default;
    }
  });

  _Object$defineProperty(_exports, "RichText", {
    enumerable: true,
    get: function get() {
      return _RichText2.default;
    }
  });

  _Object$defineProperty(_exports, "Sticker", {
    enumerable: true,
    get: function get() {
      return _Sticker2.default;
    }
  });

  _Object$defineProperty(_exports, "Tag", {
    enumerable: true,
    get: function get() {
      return _Tag2.default;
    }
  });

  _Object$defineProperty(_exports, "VideoThumbnail", {
    enumerable: true,
    get: function get() {
      return _VideoThumbnail2.default;
    }
  });

  _Object$defineProperty(_exports, "ScrollTop", {
    enumerable: true,
    get: function get() {
      return _ScrollTop2.default;
    }
  });

  _Object$defineProperty(_exports, "TitlePlaceholder", {
    enumerable: true,
    get: function get() {
      return _TitlePlaceholder2.default;
    }
  });

  _Object$defineProperty(_exports, "VideoEmbed", {
    enumerable: true,
    get: function get() {
      return _VideoEmbed2.default;
    }
  });

  _Object$defineProperty(_exports, "NoResult", {
    enumerable: true,
    get: function get() {
      return _NoResult2.default;
    }
  });

  _Object$defineProperty(_exports, "NextFooter", {
    enumerable: true,
    get: function get() {
      return _NextFooter2.default;
    }
  });

  _Object$defineProperty(_exports, "NextMenu", {
    enumerable: true,
    get: function get() {
      return _NextMenu2.default;
    }
  });

  _Object$defineProperty(_exports, "BigBanner", {
    enumerable: true,
    get: function get() {
      return _BigBanner2.default;
    }
  });

  _Object$defineProperty(_exports, "Banner", {
    enumerable: true,
    get: function get() {
      return _Banner2.default;
    }
  });

  _Object$defineProperty(_exports, "CookieBanner", {
    enumerable: true,
    get: function get() {
      return _CookieBanner2.default;
    }
  });

  _Object$defineProperty(_exports, "TeaserMain", {
    enumerable: true,
    get: function get() {
      return _TeaserMain2.default;
    }
  });

  _Object$defineProperty(_exports, "TeaserSeeAll", {
    enumerable: true,
    get: function get() {
      return _TeaserSeeAll2.default;
    }
  });

  _Object$defineProperty(_exports, "TeaserShow", {
    enumerable: true,
    get: function get() {
      return _TeaserShow2.default;
    }
  });

  _Object$defineProperty(_exports, "TeaserSidebar", {
    enumerable: true,
    get: function get() {
      return _TeaserSidebar2.default;
    }
  });

  _Object$defineProperty(_exports, "TeaserVideo", {
    enumerable: true,
    get: function get() {
      return _TeaserVideo2.default;
    }
  });

  _Object$defineProperty(_exports, "TeaserVOD", {
    enumerable: true,
    get: function get() {
      return _TeaserVOD2.default;
    }
  });

  _Object$defineProperty(_exports, "TeasersList", {
    enumerable: true,
    get: function get() {
      return _TeasersList2.default;
    }
  });

  _Object$defineProperty(_exports, "TeasersRow", {
    enumerable: true,
    get: function get() {
      return _TeasersRow2.default;
    }
  });

  _Object$defineProperty(_exports, "TeaserPreview", {
    enumerable: true,
    get: function get() {
      return _TeaserPreview2.default;
    }
  });

  _Object$defineProperty(_exports, "LandscapeSlider", {
    enumerable: true,
    get: function get() {
      return _LandscapeSlider2.default;
    }
  });

  _Object$defineProperty(_exports, "SmallSquareSlider", {
    enumerable: true,
    get: function get() {
      return _SmallSquareSlider2.default;
    }
  });

  _Object$defineProperty(_exports, "SingleLineSlider", {
    enumerable: true,
    get: function get() {
      return _SingleLineSlider2.default;
    }
  });

  _Object$defineProperty(_exports, "MultiLineSlider", {
    enumerable: true,
    get: function get() {
      return _MultiLineSlider2.default;
    }
  });

  _Object$defineProperty(_exports, "HomeMainSlider", {
    enumerable: true,
    get: function get() {
      return _HomeMainSlider2.default;
    }
  });

  _Object$defineProperty(_exports, "PortraitSlider", {
    enumerable: true,
    get: function get() {
      return _PortraitSlider2.default;
    }
  });

  _Object$defineProperty(_exports, "Link", {
    enumerable: true,
    get: function get() {
      return _Link2.default;
    }
  });

  _Object$defineProperty(_exports, "LinksList", {
    enumerable: true,
    get: function get() {
      return _LinksList2.default;
    }
  });

  _Object$defineProperty(_exports, "NavBar", {
    enumerable: true,
    get: function get() {
      return _NavBar2.default;
    }
  });

  _Object$defineProperty(_exports, "NavBarLink", {
    enumerable: true,
    get: function get() {
      return _NavBarLink2.default;
    }
  });

  _Object$defineProperty(_exports, "SectionBreadcrumb", {
    enumerable: true,
    get: function get() {
      return _SectionBreadcrumb2.default;
    }
  });

  _Object$defineProperty(_exports, "SectionTitle", {
    enumerable: true,
    get: function get() {
      return _SectionTitle2.default;
    }
  });

  _Object$defineProperty(_exports, "ProgramTimeline", {
    enumerable: true,
    get: function get() {
      return _ProgramTimeline2.default;
    }
  });

  _Object$defineProperty(_exports, "GuideDaySlide", {
    enumerable: true,
    get: function get() {
      return _GuideDaySlide2.default;
    }
  });

  _Object$defineProperty(_exports, "GuideDaySlider", {
    enumerable: true,
    get: function get() {
      return _GuideDaySlider2.default;
    }
  });

  _Object$defineProperty(_exports, "GuideMainSlider", {
    enumerable: true,
    get: function get() {
      return _GuideMainSlider2.default;
    }
  });

  _Object$defineProperty(_exports, "GuideProgram", {
    enumerable: true,
    get: function get() {
      return _GuideProgram2.default;
    }
  });

  _Object$defineProperty(_exports, "PreviousPrograms", {
    enumerable: true,
    get: function get() {
      return _PreviousPrograms2.default;
    }
  });

  _Object$defineProperty(_exports, "Breadcrumb", {
    enumerable: true,
    get: function get() {
      return _ProgramBreadcrumb.default;
    }
  });

  _Object$defineProperty(_exports, "Cartridge", {
    enumerable: true,
    get: function get() {
      return _ProgramCartridge.default;
    }
  });

  _Object$defineProperty(_exports, "Credits", {
    enumerable: true,
    get: function get() {
      return _ProgramCredits.default;
    }
  });

  _Object$defineProperty(_exports, "ExternalLinks", {
    enumerable: true,
    get: function get() {
      return _ProgramExternalLinks.default;
    }
  });

  _Object$defineProperty(_exports, "MetasInfos", {
    enumerable: true,
    get: function get() {
      return _ProgramInfos.default;
    }
  });

  _Object$defineProperty(_exports, "TeasersSidebar", {
    enumerable: true,
    get: function get() {
      return _ProgramSidebar.default;
    }
  });

  _Object$defineProperty(_exports, "TeasersPlaylist", {
    enumerable: true,
    get: function get() {
      return _ProgramPlaylist.default;
    }
  });

  _Object$defineProperty(_exports, "DurationFilter", {
    enumerable: true,
    get: function get() {
      return _SearchDurationFilter.default;
    }
  });

  _Object$defineProperty(_exports, "SearchInput", {
    enumerable: true,
    get: function get() {
      return _SearchInput2.default;
    }
  });

  _Object$defineProperty(_exports, "SearchTeaser", {
    enumerable: true,
    get: function get() {
      return _SearchTeaser2.default;
    }
  });

  _Object$defineProperty(_exports, "SearchTeasersList", {
    enumerable: true,
    get: function get() {
      return _SearchTeasersList2.default;
    }
  });

  _Object$defineProperty(_exports, "CollectionDescription", {
    enumerable: true,
    get: function get() {
      return _CollectionDescription2.default;
    }
  });

  _Object$defineProperty(_exports, "LiveInfos", {
    enumerable: true,
    get: function get() {
      return _LiveInfos2.default;
    }
  });

  _Object$defineProperty(_exports, "DateLabel", {
    enumerable: true,
    get: function get() {
      return _DateLabel2.default;
    }
  });

  _Object$defineProperty(_exports, "Quote", {
    enumerable: true,
    get: function get() {
      return _Quote2.default;
    }
  });

  _Object$defineProperty(_exports, "ImageWithLegend", {
    enumerable: true,
    get: function get() {
      return _ImageWithLegend2.default;
    }
  });

  _Object$defineProperty(_exports, "SocialMedia", {
    enumerable: true,
    get: function get() {
      return _SocialMedia2.default;
    }
  });

  _Object$defineProperty(_exports, "Carousel", {
    enumerable: true,
    get: function get() {
      return _Carousel2.default;
    }
  });

  _Object$defineProperty(_exports, "AfpImage", {
    enumerable: true,
    get: function get() {
      return _AfpImage2.default;
    }
  });

  _Object$defineProperty(_exports, "TeaserEvent", {
    enumerable: true,
    get: function get() {
      return _TeaserEvent2.default;
    }
  });

  _Object$defineProperty(_exports, "TeaserEventInfos", {
    enumerable: true,
    get: function get() {
      return _TeaserEventInfos2.default;
    }
  });

  _Object$defineProperty(_exports, "PresseTeaserLandscape", {
    enumerable: true,
    get: function get() {
      return _TeaserLandscape.default;
    }
  });

  _Object$defineProperty(_exports, "HomeMainCarousel", {
    enumerable: true,
    get: function get() {
      return _HomeMainCarousel2.default;
    }
  });

  _Button2 = _interopRequireDefault(_Button2);
  _ConcertButton2 = _interopRequireDefault(_ConcertButton2);
  _Dropdown2 = _interopRequireDefault(_Dropdown2);
  _Icon2 = _interopRequireDefault(_Icon2);
  _IconSvg2 = _interopRequireDefault(_IconSvg2);
  _Interchange2 = _interopRequireDefault(_Interchange2);
  _LandscapeImage2 = _interopRequireDefault(_LandscapeImage2);
  _LinkImageListConcert2 = _interopRequireDefault(_LinkImageListConcert2);
  _Loader2 = _interopRequireDefault(_Loader2);
  _Modal2 = _interopRequireDefault(_Modal2);
  _NextSharebar2 = _interopRequireDefault(_NextSharebar2);
  _NextSubscribe2 = _interopRequireDefault(_NextSubscribe2);
  _Overlay2 = _interopRequireDefault(_Overlay2);
  _RichText2 = _interopRequireDefault(_RichText2);
  _Sticker2 = _interopRequireDefault(_Sticker2);
  _Tag2 = _interopRequireDefault(_Tag2);
  _VideoThumbnail2 = _interopRequireDefault(_VideoThumbnail2);
  _ScrollTop2 = _interopRequireDefault(_ScrollTop2);
  _TitlePlaceholder2 = _interopRequireDefault(_TitlePlaceholder2);
  _VideoEmbed2 = _interopRequireDefault(_VideoEmbed2);
  _NoResult2 = _interopRequireDefault(_NoResult2);
  _NextFooter2 = _interopRequireDefault(_NextFooter2);
  _NextMenu2 = _interopRequireDefault(_NextMenu2);
  _BigBanner2 = _interopRequireDefault(_BigBanner2);
  _Banner2 = _interopRequireDefault(_Banner2);
  _CookieBanner2 = _interopRequireDefault(_CookieBanner2);
  _TeaserMain2 = _interopRequireDefault(_TeaserMain2);
  _TeaserSeeAll2 = _interopRequireDefault(_TeaserSeeAll2);
  _TeaserShow2 = _interopRequireDefault(_TeaserShow2);
  _TeaserSidebar2 = _interopRequireDefault(_TeaserSidebar2);
  _TeaserVideo2 = _interopRequireDefault(_TeaserVideo2);
  _TeaserVOD2 = _interopRequireDefault(_TeaserVOD2);
  _TeasersList2 = _interopRequireDefault(_TeasersList2);
  _TeasersRow2 = _interopRequireDefault(_TeasersRow2);
  _TeaserPreview2 = _interopRequireDefault(_TeaserPreview2);
  _LandscapeSlider2 = _interopRequireDefault(_LandscapeSlider2);
  _SmallSquareSlider2 = _interopRequireDefault(_SmallSquareSlider2);
  _SingleLineSlider2 = _interopRequireDefault(_SingleLineSlider2);
  _MultiLineSlider2 = _interopRequireDefault(_MultiLineSlider2);
  _HomeMainSlider2 = _interopRequireDefault(_HomeMainSlider2);
  _PortraitSlider2 = _interopRequireDefault(_PortraitSlider2);
  _Link2 = _interopRequireDefault(_Link2);
  _LinksList2 = _interopRequireDefault(_LinksList2);
  _NavBar2 = _interopRequireDefault(_NavBar2);
  _NavBarLink2 = _interopRequireDefault(_NavBarLink2);
  _SectionBreadcrumb2 = _interopRequireDefault(_SectionBreadcrumb2);
  _SectionTitle2 = _interopRequireDefault(_SectionTitle2);
  _ProgramTimeline2 = _interopRequireDefault(_ProgramTimeline2);
  _GuideDaySlide2 = _interopRequireDefault(_GuideDaySlide2);
  _GuideDaySlider2 = _interopRequireDefault(_GuideDaySlider2);
  _GuideMainSlider2 = _interopRequireDefault(_GuideMainSlider2);
  _GuideProgram2 = _interopRequireDefault(_GuideProgram2);
  _PreviousPrograms2 = _interopRequireDefault(_PreviousPrograms2);
  _ProgramBreadcrumb = _interopRequireDefault(_ProgramBreadcrumb);
  _ProgramCartridge = _interopRequireDefault(_ProgramCartridge);
  _ProgramCredits = _interopRequireDefault(_ProgramCredits);
  _ProgramExternalLinks = _interopRequireDefault(_ProgramExternalLinks);
  _ProgramInfos = _interopRequireDefault(_ProgramInfos);
  _ProgramSidebar = _interopRequireDefault(_ProgramSidebar);
  _ProgramPlaylist = _interopRequireDefault(_ProgramPlaylist);
  _SearchDurationFilter = _interopRequireDefault(_SearchDurationFilter);
  _SearchInput2 = _interopRequireDefault(_SearchInput2);
  _SearchTeaser2 = _interopRequireDefault(_SearchTeaser2);
  _SearchTeasersList2 = _interopRequireDefault(_SearchTeasersList2);
  _CollectionDescription2 = _interopRequireDefault(_CollectionDescription2);
  _LiveInfos2 = _interopRequireDefault(_LiveInfos2);
  _DateLabel2 = _interopRequireDefault(_DateLabel2);
  _Quote2 = _interopRequireDefault(_Quote2);
  _ImageWithLegend2 = _interopRequireDefault(_ImageWithLegend2);
  _SocialMedia2 = _interopRequireDefault(_SocialMedia2);
  _Carousel2 = _interopRequireDefault(_Carousel2);
  _AfpImage2 = _interopRequireDefault(_AfpImage2);
  _TeaserEvent2 = _interopRequireDefault(_TeaserEvent2);
  _TeaserEventInfos2 = _interopRequireDefault(_TeaserEventInfos2);
  _TeaserLandscape = _interopRequireDefault(_TeaserLandscape);
  _HomeMainCarousel2 = _interopRequireDefault(_HomeMainCarousel2);
});